import styled from 'styled-components';
import { rgba } from 'polished';
import colors from 'constants/colors';

const ScheduledActivitiesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: flex-start;

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(3, 80%);
  }
`;

export const ScrollFade = styled.div`
  position: relative;

  @media screen and (max-width: 992px) {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 40px;
      pointer-events: none;
      background: linear-gradient(to left, ${colors.main.white}, ${rgba(colors.main.white, 0)});
    }
  }
`;

export default ScheduledActivitiesWrapper;
